module.exports = __webpack_public_path__ + "img/_cursor_grab.b8f57f36.svg";